module.exports = __webpack_public_path__ + "ye.40c9a45652a520a4ceb9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ye.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ye.svg
// module chunks = styles